import React from 'react';
import LandingPage from '../Landing';

class LandingPage3 extends React.Component {

  render() {
    const headerPosStyle = {
      position: 'relative',
      top: '50%'
    };

    const h2Style = { 
      display: "inline-block",
      color: "#E1E1E1",
      backgroundColor: "#252525",
      fontSize: "35px",
      margin: "0.1em 0.5em 0",
      paddingLeft: "2px",
      paddingRight: "20px",
    };

    const longStyle = {
      marginTop: "0.5em",
      paddingRight: "60px"
    }

    const extraLongStyle = {
      paddingRight: "37px"
    }

    const reverseStyle = {
      backgroundColor: "#E1E1E1",
      color: "#252525"
    }

    return (
      <LandingPage className="landingPage2" bgImg={this.props.bgImg} >

        <div>
          <p style={ {...h2Style, ...longStyle} }>SO GET</p>
          <p style={ {...h2Style, ...extraLongStyle} }>READY TO</p><br/>
          <p style={ {...h2Style, ...reverseStyle} }>LEVEL UP</p><br/>
          <p style={ {...h2Style, ...reverseStyle} }>YOUR REAL</p><br/>
          <p style={ {...h2Style, ...reverseStyle} }>LIFE...</p><br/>
        </div>

      </LandingPage>
    );
  }
}

export default LandingPage3;



// WEBPACK FOOTER //
// ./src/components/LandingPage3/index.js